// src/context/CartContext.js
import { createContext, useContext, useState, useEffect } from "react";
import { apiUrl } from "../../config/config";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartCount, setCartCount] = useState(0);

  // Fetch latest cart count from backend
  const refreshCart = async () => {
    let user = JSON.parse(localStorage.getItem("user"));
    let guest_id = localStorage.getItem("guest_id");

    let url = user?.id
      ? `${apiUrl}/api/cart/user/${user.id}`
      : `${apiUrl}/api/cart?guest_id=${guest_id}`;

    try {
      const res = await fetch(url);
      const data = await res.json();

      if (data.success) {
        setCartCount(data.data.length); // 👈 Update count correctly
      }
    } catch (err) {
      console.error("Cart count refresh error:", err);
    }
  };

  // Load once on app start
  useEffect(() => {
    refreshCart();
  }, []);

  return (
    <CartContext.Provider value={{ cartCount, refreshCart }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
